export enum BREAKPOINTS {
  xs = '(max-width: 575px)',
  sm = '(max-width: 767px)',
  md = '(max-width: 991px)',
  lg = '(max-width: 1199px)',
  xl = '(max-width: 1399px)',
  xxl = '(min-width: 1400px)',
}
